module.exports = __webpack_public_path__ + "img/logo-hotelv-thelobby-light.b203da632b1d9835537513ebf9e7a5c5.svg";